import React from 'react'
import { useTranslation } from 'react-i18next'

import type { Route } from '@/components/Tabs/Tabs'
import BasicLayout, {
  type HeaderAction
} from '@/components/common/BasicLayout/BasicLayout'
import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'
import { useFeatureFlag } from '@/hooks/useFeatureFlag'

import type { SchoolYearAndBreakCommonFilter } from '../constants/school-settings-filters'

type SchoolSettingsViewProps = {
  children: React.ReactNode
  actions?: HeaderAction[]
  contentClassName?: string
}

const SchoolSettingsView = (props: SchoolSettingsViewProps) => {
  const { t } = useTranslation('schoolSettings')

  const enabledSchoolYears = useFeatureFlag('IS_SCHOOL_YEARS_MODULE_ENABLED')
  const enabledSchoolBreaks = useFeatureFlag('IS_SCHOOL_BREAKS_MODULE_ENABLED')
  const enabledSchoolDay = useFeatureFlag('IS_SCHOOL_DAY_MODULE_ENABLED')

  const search: SchoolYearAndBreakCommonFilter = {
    status: 'active-and-future',
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE
  }

  const routes: Route[] = [
    {
      title: t('navigation.school-years'),
      link: {
        to: '/school-settings/years',
        search
      },
      hidden: !enabledSchoolYears
    },
    {
      title: t('navigation.school-breaks'),
      link: {
        to: '/school-settings/breaks',
        search
      },
      hidden: !enabledSchoolBreaks
    },
    {
      title: t('navigation.school-day'),
      link: {
        to: '/school-settings/day'
      },
      hidden: !enabledSchoolDay
    }
  ]

  return (
    <BasicLayout
      header={t('header.school-settings')}
      routes={routes}
      moduleName={t('header.administration', { ns: 'common' })}
      breadcrumbs={[
        { title: t('header.school-settings'), to: '/school-settings/years' }
      ]}
      actions={props.actions}
      actionsAsDropdown={!!props.actions}
      contentClassName={props.contentClassName}
    >
      {props.children}
    </BasicLayout>
  )
}
export default SchoolSettingsView
